<script setup>
import { toRefs } from "vue";
import { formatearInputMoneda, ocultarNombre } from "@/utils/helpers";

const props = defineProps({
  movimientos: { type: Array, default: () => [] },
  usuario_id: { type: Number, default: null },
});

const { movimientos, usuario_id } = toRefs(props);

const formatName = (oferta) => {
  const uw = oferta?.user_web ?? {};
  const base =
    (uw.name || uw.lastname)
      ? `${uw.name ? uw.name + " " : ""}${uw.lastname ?? ""}`.trim()
      : (uw.email || "anonimo");

  return usuario_id.value === uw.id ? base : ocultarNombre(base);
};
</script>

<template>
  <div class="d-flex w-100 mt-2">
    <div class="tabla-container w-100">
      <table
        v-if="movimientos.length"
        class="table table-striped table-borderless table_font mb-0"
      >
        <tbody>
          <tr
            v-for="(oferta, index) in movimientos"
            :key="oferta.id ?? index"
            :class="{ ganador: usuario_id === oferta?.user_web?.id }"
          >
            <td>{{ formatName(oferta) }}</td>
            <td>{{ oferta.fecha_hora }}</td>
            <td class="align-self-end rounded-end border-0">
              <div class="text-end">
                $ {{ formatearInputMoneda(oferta.oferta_actual) }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-else class="text-muted small">Sin movimientos todavía.</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ganador > td {
  color: green !important;
  font-weight: bolder;
}

.table_font {
  font-size: small;
}

.tabla-container {
  max-height: calc(5 * 45px);
  overflow-y: auto;
  display: block;
}

.tabla-container::-webkit-scrollbar { width: 6px; }
.tabla-container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

@media (max-width: 660px) {
  .table_font { font-size: x-small; }
}
</style>
